export interface GtmConfig {
  gtmId: string
  auth?: string
  preview?: string
}

export function getGtmConfig(): GtmConfig {
  return {
    gtmId: process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID!,
    auth: process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH!,
    preview: process.env.NEXT_PUBLIC_ANALYTICS_GTM_PREVIEW!,
  }
}
